// TITLES COLOR

var pageArticle = document.querySelector('[data-section-type="article"]');
if (pageArticle == undefined) {
  setTimeout(() => {
    document.querySelectorAll('h1 span, h2 span, h3 span, h4 span').forEach((title) => {
      var titleInner = title.innerText;
      var newTitle = '';
      for (var i = 0; i < titleInner.length; i++) {
        if (titleInner[i] != ' ') {
          newTitle = newTitle + '<p>' + titleInner[i] + '</p>';
        } else {
          newTitle = newTitle + "<p class='whitespace'>" + titleInner[i + 1] + '</p>';
          i++;
        }
      }
      title.innerHTML = newTitle;
    });
  }, 1000);
}

// SLIDE TOGGLE
var linkToggle = document.querySelectorAll('[data-faq-question]');
for (i = 0; i < linkToggle.length; i++) {
  linkToggle[i].addEventListener('click', function (event) {
    event.preventDefault();
    var container = event.target.nextElementSibling;

    // On click remove all active classes
    var parent = event.target.closest('[data-faq-blocks]');
    var childs = parent.querySelectorAll('[data-faq-answer]');
    childs.forEach((child) => {
      if (child.classList.contains('active') && child != container) {
        closeContaier(child);
      }
    });

    // Show or hide current question answer
    if (!container.classList.contains('active')) {
      openContainer(container);
    } else {
      closeContaier(container);
    }
  });
}

function openContainer(container) {
  container.classList.add('active');
  container.style.height = 'auto';
  var height = container.clientHeight + 'px';
  container.style.height = '0px';
  setTimeout(function () {
    container.style.height = height;
  }, 0);
}

function closeContaier(container) {
  container.style.height = '0px';
  container.addEventListener(
    'transitionend',
    function () {
      container.classList.remove('active');
    },
    {
      once: true,
    }
  );
}

var btnFixed = document.getElementsByClassName('btn--fixed')[0];
if (btnFixed != null && btnFixed != undefined) {
  toggleFixedButton(btnFixed);
}

// Scroll left / right

if (document.querySelector('[data-thumbs-left]') != undefined && document.querySelector('[data-thumbs-right]') != undefined) {
  document.querySelector('[data-thumbs-left]').addEventListener('click', (event) => {
    smoothScroll(document.querySelector('[data-thumbs-slider]'), -150);
  });
  document.querySelector('[data-thumbs-right]').addEventListener('click', (event) => {
    smoothScroll(document.querySelector('[data-thumbs-slider]'), 150);
  });
}

function smoothScroll(el, value) {
  el.scrollBy({
    top: 0,
    left: value,
    behavior: 'smooth',
  });

  // Loop to first thumb when last thumb is reached
  var thumbsWidth = el.clientWidth,
    thumbsItems = el.querySelectorAll('[data-thumb-item]'),
    lastThumb = thumbsItems[thumbsItems.length - 1],
    lastThumbXPos = lastThumb.getBoundingClientRect().x,
    thumbWidth = lastThumb.clientWidth;

  if (lastThumbXPos < thumbsWidth) {
    value = -1 * thumbsItems.length * (thumbWidth + 10);

    el.scrollBy({
      top: 0,
      left: value,
      behavior: 'smooth',
    });
  }
}

// SCROLL
window.addEventListener('scroll', function () {
  if (btnFixed != null && btnFixed != undefined) {
    toggleFixedButton(btnFixed);
  }
});

function toggleFixedButton(btnFixed) {
  var currentScrollPos = document.documentElement.scrollTop || document.body.scrollTop;
  var screenHeight = window.innerHeight;
  var fixedSections = document.querySelectorAll('.section.fixed-bottom');

  if (currentScrollPos < screenHeight) {
    btnFixed.classList.add('hide');
    fixedSections.forEach((section) => {
      section.closest('.shopify-section').style.display = 'block';
    });
  } else {
    btnFixed.classList.remove('hide');
    fixedSections.forEach((section) => {
      section.closest('.shopify-section').style.display = 'none';
    });
  }
}

var productFormPack = '.product-form--pack';

function addPackProductToCart(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: {
        isBundle: 'true',
      },
    }),
  })
    .then(async function (response) {
      if (response.ok) {
        var cart = await getCartJSON();
        var count = getNbrPackProducts(cart);

        updatePopupPackPrice(cart);
        showPackPopup(count);
      } else {
        alert('Une erreur est survenue, si le problème persiste merci de contacter le support');
      }
    })
    .catch(function (err) {
      var status = JSON.parse(err.responseText).status;
      if (status == 422) {
        alert('Ce produit est en rupture de stock');
      } else {
        alert('Une erreur est survenue, si le problème persiste merci de contacter le support');
      }
    });
}

function getNbrPackProducts(cart) {
  var nbrCartProducts = cart.item_count;
  var count = 0;

  document.querySelectorAll('[data-cart-count]').forEach((cartCount) => {
    cartCount.innerHTML = nbrCartProducts;
    cartCount.dataset.cartCount = nbrCartProducts;
  });

  cart.items.forEach((item) => {
    if (item.properties['isBundle'] != undefined && item.properties['isBundle'] == 'true') count = count + item.quantity;
  });

  return count;
}

function updatePopupPackPrice(cart) {
  var itemsSubtotalPrice = (cart.items_subtotal_price / 100).toFixed(2);
  var originalTotalPrice = (cart.original_total_price / 100).toFixed(2);
  var currency = '$';
  if (cart.currency == 'EUR') currency = '€';

  var packPrice = itemsSubtotalPrice + currency;

  if (itemsSubtotalPrice != originalTotalPrice) {
    packPrice = '<del>' + originalTotalPrice + currency + '</del>' + packPrice;
  }

  packPrice = packPrice.replaceAll('.', ',');

  document.querySelector('[data-popup-pack-price]').innerHTML = packPrice;
}

function showPackPopup(count) {
  var congratz = false;
  var nbrProductsBeforeReduction = 0;
  var reduction = '10%';

  if (count < 3) {
    nbrProductsBeforeReduction = 3 - count;
  } else if (count == 3) {
    congratz = true;
  } else if (count < 5) {
    nbrProductsBeforeReduction = 5 - count;
    reduction = '15%';
  } else if (count == 5) {
    congratz = true;
    reduction = '15%';
  } else if (count < 7) {
    nbrProductsBeforeReduction = 7 - count;
    reduction = '20%';
  } else {
    congratz = true;
    reduction = '20%';
  }

  if (congratz) {
    document.querySelector('.popup-pack__model-1').classList.add('hide');
    document.querySelector('.popup-pack__model-2').classList.remove('hide');
    document.querySelectorAll('[data-popup-pack-prc]').forEach((prc) => {
      prc.innerHTML = reduction;
    });
  } else {
    document.querySelector('.popup-pack__model-1').classList.remove('hide');
    document.querySelector('.popup-pack__model-2').classList.add('hide');
    document.querySelector('[data-popup-pack-qty]').innerHTML = nbrProductsBeforeReduction + ' article(s)';
    document.querySelectorAll('[data-popup-pack-prc]').forEach((prc) => {
      prc.innerHTML = reduction;
    });
  }

  document.querySelector('[data-popup-pack]').classList.remove('hide');
}

document.querySelectorAll('[data-pack-background]').forEach((event) => {
  event.addEventListener('click', () => {
    document.querySelector('[data-popup-pack]').classList.add('hide');
  });
});

if (document.querySelector('[data-popup-pack-checkout]') != undefined) {
  document.querySelector('[data-popup-pack-checkout]').addEventListener('click', () => {
    window.location.href = '/checkout';
  });
}

if (document.querySelector('.product-description__content__entry .more') != undefined) {
  document.querySelector('.product-description__content__entry .more').addEventListener('click', (event) => {
    event.preventDefault();
    document.querySelector(event.target.getAttribute('href')).scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  });
}

// PICTOS
var pictosClose = document.querySelectorAll('[data-pictos-close]');
var pictosShow = document.querySelectorAll('[data-pictos-show]');

pictosClose.forEach((buttonClose) => {
  buttonClose.addEventListener('click', () => {
    document.querySelectorAll('[data-pictos-side]').forEach((pictosContainer) => {
      pictosContainer.classList.add('hide');
    });
  });
});

pictosShow.forEach((buttonShow) => {
  buttonShow.addEventListener('click', (event) => {
    var container = event.target.closest('[data-pictos-container]');
    var content = container.querySelector('[data-pictos-side]');
    content.classList.remove('hide');
  });
});

// SHOW MORE PACK PRODUCTS
if (document.querySelector('[data-pack-see-more]') != undefined) {
  document.querySelector('[data-pack-see-more]').addEventListener('click', (event) => {
    event.target.closest('.collection__see-more-container').style.display = 'none';
    document.querySelectorAll('.product-grid .product-item').forEach((item) => {
      item.style.display = 'flex';
    });
  });
}

// UPDATE PACK VARIANTE
var radioButton = document.querySelectorAll('.radio__button input');

radioButton.forEach((button) => {
  button.addEventListener('click', (el) => {
    var container = el.target.closest('[data-product-information]');
    var form = el.target.closest('.product-form--pack');

    if (form == undefined) return false;
    var data = Object.fromEntries(new FormData(form).entries());
    var inputBundle = form.querySelector("input[name='properties[isBundle]']");
    var id = inputBundle.id.replace('bundle-', '');

    var select = form.id;

    var variantId = getVariantId(data, select);

    var dataProduct = document.querySelector("[data-product-json='" + id + "']").innerHTML;
    var dataProductJson = JSON.parse(dataProduct);

    var result = dataProductJson.variants.filter((obj) => {
      return obj.id === variantId;
    });

    var res = result[0];

    var available = res.available;
    var compareAtPrice = res.compare_at_price;
    var price = parseFloat(res.price / 100);
    price = price.toFixed(2);
    finalPrice = price.toString() + ' $';
    var image = {
      alt: res.featured_image.alt,
      src: res.featured_image.src,
    };

    container.querySelector('.card__product-price').innerHTML = price.replace('.00', '') + ' €';
    var buttonAdd = container.querySelector('[data-add-to-cart-pack]');
    if (available == true) {
      buttonAdd.disabled = false;
    } else {
      buttonAdd.disabled = true;
    }
    // TODO update image + price compared at
  });
});

function getVariantId(data, select) {
  var currentOptions = [];

  var options = Object.keys(data).filter(function (key) {
    return key.includes('options');
  });

  options.forEach((option) => {
    var optionName = option.replace('options[', '').replace(']', '');

    if (data != undefined && data[`options[${optionName}]`] != undefined) {
      currentOptions.push(data[`options[${optionName}]`]);
    }
  });

  var currentOptionValue = '';

  for (var i = 0; i < currentOptions.length; i++) {
    currentOptionValue = currentOptionValue + currentOptions[i];
    var next = i + 1;
    if (currentOptions.length != next) {
      currentOptionValue = currentOptionValue + ' / ';
    }
  }

  var variantId = undefined;
  select.querySelectorAll('option').forEach((option) => {
    if (option.innerHTML.replaceAll(/\s/g, '') == currentOptionValue.replaceAll(/\s/g, '')) {
      variantId = parseInt(option.value);
    }
  });

  return variantId;
}

// SIDECART
async function getCartJSON() {
  const result = await fetch('/cart.json');

  if (result.status === 200) {
    return result.json();
  }

  throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

if (!customElements.get('shipping-estimate')) {
  customElements.define(
    'shipping-estimate',
    class ShippingEstimate extends HTMLElement {
      constructor() {
        super();

        let selectors = {
          shippingThreshold: '[data-cart-shipping-price-threshold]',
          shippingThresholdData: 'cartShippingPriceThreshold',
          shippingPriceMin: '[data-cart-shipping-price-min]',
          shippingPriceMinData: 'cartShippingPriceMin',
          shippingPriceFree: '[data-cart-shipping-price-free]',
          shippingPriceFreeData: 'cartShippingPriceFree',
          shippingPrice: '[data-cart-shipping-price]',
          shippingDate: '[data-shipping-date-estimate]',
        };

        this.selectors = selectors;

        this.init();
      }

      async init() {
        if (this.querySelector(this.selectors.shippingThreshold) != null) {
          let threshold = this.querySelector(this.selectors.shippingThreshold).dataset[this.selectors.shippingThresholdData];
          let priceMin = this.querySelector(this.selectors.shippingPriceMin).dataset[this.selectors.shippingPriceMinData];
          let priceFree = this.querySelector(this.selectors.shippingPriceFree).dataset[this.selectors.shippingPriceFreeData];

          let priceElem = this.querySelector(this.selectors.shippingPrice);

          const cart = await getCartJSON();

          if (cart.total_price >= threshold) {
            priceElem.textContent = priceFree;
          } else {
            priceElem.textContent = priceMin;
          }
        }

        let date = this.querySelector(this.selectors.shippingDate);
        if (date != null) {
          var dateToday = new Date();
          dateToday.setDate(dateToday.getDate() + window.theme.shipping.estimatedDeliveryDays);
          date.innerText = dateToday.getDate() + ' ' + dateToday.toLocaleString('default', { month: 'long' });
        }
      }
    }
  );
}

if (!customElements.get('bundle-progressbar')) {
  customElements.define(
    'bundle-progressbar',
    class BundleProgressbar extends HTMLElement {
      constructor() {
        super();

        let selectors = {
          packSettings: '[data-pack-settings]',
          packSettingsData: 'packSettings',
          progressMax: '[data-cart-progress-bar-discount-max]',
          progressMaxData: 'cartProgressBarDiscountMax',
          progressTitle: '[data-cart-progress-bar-discount-title]',
          progressPrice: '[data-cart-progress-bar-discount-price]',
          progressMessage: '[data-cart-progress-bar-discount-message]',
          progressBar: '[data-cart-progress-bar]',
        };

        this.selectors = selectors;

        this.init();
      }

      async init() {
        if (this.querySelector(this.selectors.packSettings) != null) {
          let packSettingsData = JSON.parse(this.querySelector(this.selectors.packSettings).dataset[this.selectors.packSettingsData]);

          let progressTitle = this.querySelector(this.selectors.progressTitle);
          let progressPrice = this.querySelector(this.selectors.progressPrice);
          let progressMessage = this.querySelector(this.selectors.progressMessage);
          let progressBar = this.querySelector(this.selectors.progressBar);
          let progressMaxData = this.querySelector(this.selectors.progressMax).dataset[this.selectors.progressMaxData];

          const cart = await getCartJSON();
          document.querySelector('.form-cart').style.display = 'block';
          if (cart.items.length == 0) {
            document.querySelector('.form-cart').style.display = 'none';
          }

          var countItemPack = 0;
          for (let index = 0; index < cart.items.length; index++) {
            if (cart.items[index].properties != undefined && cart.items[index].properties.isBundle) {
              countItemPack = countItemPack + cart.items[index].quantity;
            }
          }

          // var btnCheckout = document.querySelectorAll("[tbn-core-dam-fallback-cfs]");
          // if (countItemPack == 0) {
          //   btnCheckout.forEach((btn) => {
          //     btn.style.display = "none !important";
          //   })
          // } else {
          //   btnCheckout.forEach((btn) => {
          //     btn.style.display = "flex !important";
          //   })
          // }

          if (countItemPack > parseInt(progressMaxData)) {
            countItemPack = parseInt(progressMaxData);
          }

          for (let index = 0; index < packSettingsData.length; index++) {
            if (parseInt(packSettingsData[index].treshold) == countItemPack) {
              progressTitle.innerText = packSettingsData[index].title.replace('&#39;', "'");
              progressMessage.innerText = packSettingsData[index].text.replace('&#39;', "'");
              progressPrice.innerText =
                cart.total_discount != 0 ? '-' + themeVendor.themeCurrency.formatMoney(cart.total_discount, theme.moneyFormat) : '- 0,00 €';
            }
          }

          progressBar.style.width = (countItemPack * 100) / 7 + '%';
        }
      }
    }
  );
}

if (!customElements.get('progress-bar')) {
  customElements.define(
    'progress-bar',
    class ProgressBar extends HTMLElement {
      constructor() {
        super();

        let selectors = {
          packSettings: '[data-pack-settings]',
          packSettingsData: 'packSettings',
          packText: '[data-progress-text]',
          packTextData: 'progressText',
          packSuccessText: '[data-progress-success-text]',
          packSuccessTextData: 'progressSuccessText',
          progressMax: '[data-cart-progress-bar-discount-max]',
          progressMaxData: 'cartProgressBarDiscountMax',
          progressTitle: '[data-cart-progress-bar-discount-title]',
          progressPrice: '[data-cart-progress-bar-discount-price]',
          progressMessage: '[data-cart-progress-bar-discount-message]',
          progressBar: '[data-cart-progress-bar]',
          progressBar1: '#progressbar1',
          progressBar2: '#progressbar2',
          progressBar3: '#progressbar3',
        };

        this.selectors = selectors;

        this.init();
      }

      async init() {
        if (this.querySelector(this.selectors.packSettings) != null) {
          let packSettingsData = JSON.parse(this.querySelector(this.selectors.packSettings).dataset[this.selectors.packSettingsData]);
          let packSettingsText = this.querySelector(this.selectors.packText).dataset[this.selectors.packTextData];
          let packSettingsSuccessText = this.querySelector(this.selectors.packSuccessText).dataset[this.selectors.packSuccessTextData];

          let nextStep = null;

          let progressPrice = document.querySelector('.cart_progress_savings');
          let cartTotalMoney = document.querySelector('.cart-total-money');
          let progressMessage = this.querySelector(this.selectors.progressMessage);
          let progressBar1 = this.querySelector(this.selectors.progressBar1);
          let progressBar2 = this.querySelector(this.selectors.progressBar2);
          let progressBar3 = this.querySelector(this.selectors.progressBar3);

          let maxStep = 0;
          packSettingsData.forEach((item) => {
            if (item.step > maxStep) {
              maxStep = item.step;
            }
          });

          let progressMaxData = maxStep;

          let cartRea = document.querySelector('.cart-drawer-reassurances-wrapper');

          const cart = await getCartJSON();
          document.querySelector('.form-cart').style.display = 'block';
          this.style.display = 'block';
          if (cartRea != null) {
            cartRea.style.display = 'block';
          }
          if (cart.items.length == 0) {
            document.querySelector('.form-cart').style.display = 'none';
            this.style.display = 'none';
            if (cartRea != null) {
              cartRea.style.display = 'none';
            }
          }

          cartTotalMoney.innerText = themeVendor.themeCurrency.formatMoney(cart.original_total_price, theme.moneyFormat);

          var countItemPack = 0;
          for (let index = 0; index < cart.items.length; index++) {
            if (cart.items[index].properties != undefined && cart.items[index].properties._isBundle) {
              countItemPack = countItemPack + cart.items[index].quantity;
            }

            if (cart.items[index].properties != undefined && cart.items[index].properties.pack) {
              countItemPack = countItemPack + cart.items[index].quantity * cart.items[index].properties.pack;
            }
          }

          if (countItemPack > parseInt(progressMaxData)) {
            countItemPack = parseInt(progressMaxData);
          }

          for (let i = 0; i < packSettingsData.length; i++) {
            if (parseInt(packSettingsData[i].step) > countItemPack) {
              nextStep = packSettingsData[i];
              break;
            }
          }

          if (nextStep == null) progressMessage.innerText = packSettingsSuccessText;
          else
            progressMessage.innerText = packSettingsText
              .replace('||count||', nextStep.step - countItemPack)
              .replace('||discount||', nextStep.reduction);

          if (progressPrice) {
            progressPrice.innerText =
              cart.total_discount != 0 ? '-' + themeVendor.themeCurrency.formatMoney(cart.total_discount, theme.moneyFormat) : '- 0,00 €';
          }

          let progressValues = [0, 0, 0];
          let thresholds = [];
          packSettingsData.forEach((item) => {
            thresholds.push(item.step);
          });
          let remainingItems = countItemPack;

          let totalItemsBetweenSteps = [];
          for (let i = 1; i < packSettingsData.length; i++) {
            let itemsBetweenSteps = packSettingsData[i].step - packSettingsData[i - 1].step;
            totalItemsBetweenSteps.push(itemsBetweenSteps);
          }

          for (let i = 0; i < packSettingsData.length; i++) {
            const step = packSettingsData[i].step;
            const progressBarIndex = i;

            let totalItemsInRange;
            if (i === 0) {
              totalItemsInRange = step;
            } else if (i === packSettingsData.length - 1) {
              totalItemsInRange = step - packSettingsData[i - 1].step;
            } else {
              totalItemsInRange = totalItemsBetweenSteps[i - 1];
            }

            if (remainingItems <= 0) break;

            const itemsInRange = Math.min(remainingItems, totalItemsInRange);
            const progress = (itemsInRange / totalItemsInRange) * 100;

            progressValues[progressBarIndex] = progress;

            remainingItems -= itemsInRange;
          }

          progressBar1.value = progressValues[0];
          progressBar2.value = progressValues[1];
          progressBar3.value = progressValues[2];
        }
      }
    }
  );
}

if (!customElements.get('reward-progress-bar')) {
  customElements.define(
    'reward-progress-bar',
    class RewardProgressBar extends HTMLElement {
      constructor() {
        super();

        let selectors = {
          settings: '[data-settings]',
          settingsData: 'settings',
          finalTextData: 'finalText',
          progressMessage: '[data-cart-progress-bar-message]',
          progressBar: '[data-cart-progress-bar]',
          progressTreshold: '[data-treshold]',
        };

        this.selectors = selectors;

        this.init();
      }

      async init() {
        if (this.querySelector(this.selectors.settings) != null) {
          let settingsData = JSON.parse(this.querySelector(this.selectors.settings).dataset[this.selectors.settingsData]);
          let finalTextData = this.querySelector(this.selectors.settings).dataset[this.selectors.finalTextData];
          let progressMessage = this.querySelector(this.selectors.progressMessage);
          let progressBar = this.querySelector(this.selectors.progressBar);
          let progressTresholds = this.querySelectorAll(this.selectors.progressTreshold);
          let progressMaxTreshold = settingsData[settingsData.length - 1].treshold;
          let progressBarWidth = progressBar.offsetWidth;
          let progressBarPreviousStepPosition = 0;
          let progressBarPreviousStepTreshold = 0;
          let progressBarNextStepPosition = 1;
          let progressBarNextStepTreshold = parseInt(settingsData[0].treshold);
          let progressStepIndex = 0;
          let amountLeftForNextTreshold = 0;

          const cart = await getCartJSON();
          const cartTotalPrice = cart.total_price;

          this.style.display = 'block';
          if (cart.items.length == 0) this.style.display = 'none';

          for (let index = 0; index < settingsData.length; index++) {
            if (cartTotalPrice >= parseInt(settingsData[index].treshold)) {
              progressTresholds[index].classList.add('active');
              progressBarPreviousStepPosition = index + 1;
              progressBarPreviousStepTreshold = parseInt(settingsData[index].treshold);

              if (index < settingsData.length - 1) {
                progressStepIndex = index + 1;
                progressBarNextStepPosition = index + 2;
                progressBarNextStepTreshold = parseInt(settingsData[progressStepIndex].treshold);
              } else {
                progressStepIndex = index;
                progressBarNextStepPosition = index + 1;
                progressBarNextStepTreshold = parseInt(settingsData[progressStepIndex].treshold);
              }
            } else {
              progressTresholds[index].classList.remove('active');
            }
          }

          let tresholdRange = progressBarNextStepTreshold - progressBarPreviousStepTreshold;
          let amountFromPreviousStep = cartTotalPrice - progressBarPreviousStepTreshold;
          let percentFromPreviousStep = (amountFromPreviousStep * 100) / tresholdRange;

          let progressBarStepWidth = 200 / settingsData.length / 2;
          let progressBarPreviousStepWidth = (progressBarPreviousStepPosition * 2 - 1) * progressBarStepWidth;
          let progressBarNextStepWidth = (progressBarNextStepPosition * 2 - 1) * progressBarStepWidth;

          if (progressBarPreviousStepWidth < 0) progressBarPreviousStepWidth = 0;

          let widthRange = progressBarNextStepWidth - progressBarPreviousStepWidth;
          let percentDistanceFromPreviousStep = (widthRange * percentFromPreviousStep) / 100;

          if (cartTotalPrice < parseInt(progressMaxTreshold)) {
            const hasSisterForLife = cart.items.some(item => {
              return item.handle === 'sister-for-life';
            });

            if (hasSisterForLife) {
              progressMessage.innerHTML = finalTextData;
              progressBarWidth = 100;
            } else {
              amountLeftForNextTreshold = progressBarNextStepTreshold - cartTotalPrice;
              amountLeftForNextTreshold = themeVendor.themeCurrency.formatMoney(amountLeftForNextTreshold, theme.moneyFormat);
              progressMessage.innerHTML = settingsData[progressStepIndex].text.replace('&#39;', "'");
              if (progressMessage.querySelector('span') !== null)
                progressMessage.querySelector('span').textContent = amountLeftForNextTreshold;
              progressBarWidth = progressBarPreviousStepWidth + percentDistanceFromPreviousStep;
            }
          } else {
            progressMessage.innerHTML = finalTextData;
            progressBarWidth = 100;
          }

          progressBar.style.width = progressBarWidth + '%';
        }
      }
    }
  );
}

if (!customElements.get('bundle-progress-bar')) {
  customElements.define(
    'bundle-progress-bar',
    class BundleProgressBar extends HTMLElement {
      constructor() {
        super();

        let selectors = {
          settings: '[data-settings]',
          settingsData: 'settings',
          finalTextData: 'finalText',
          progressMessage: '[data-cart-progress-bar-message]',
          progressBar: '[data-cart-progress-bar]',
          progressTreshold: '[data-treshold]',
        };

        this.selectors = selectors;
        this.type = this.dataset.type;

        this.init();
      }

      async init() {
        if (this.querySelector(this.selectors.settings) != null) {
          let settingsData = JSON.parse(this.querySelector(this.selectors.settings).dataset[this.selectors.settingsData]);
          let finalTextData = this.querySelector(this.selectors.settings).dataset[this.selectors.finalTextData];
          let progressMessage = this.querySelector(this.selectors.progressMessage);
          let progressBar = this.querySelector(this.selectors.progressBar);
          let progressTresholds = this.querySelectorAll(this.selectors.progressTreshold);
          let progressMaxTreshold = settingsData[settingsData.length - 1].treshold;
          let progressBarWidth = progressBar.offsetWidth;
          let progressBarPreviousStepPosition = 0;
          let progressBarPreviousStepTreshold = 0;
          let progressBarNextStepPosition = 1;
          let progressBarNextStepTreshold = parseInt(settingsData[0].treshold);
          let progressStepIndex = 0;
          let amountLeftForNextTreshold = 0;
          let nbItemsInBundle = 0;

          if (this.type == 'cart') {
            const cart = await getCartJSON();

            for (let index = 0; index < cart.items.length; index++) {
              if (cart.items[index]['product_type'] !== 'PACK') {
                if (cart.items[index].properties != undefined && cart.items[index].properties._isBundle) {
                  nbItemsInBundle = nbItemsInBundle + cart.items[index].quantity;
                }

                if (cart.items[index].properties != undefined && cart.items[index].properties.pack) {
                  nbItemsInBundle = nbItemsInBundle + cart.items[index].quantity * cart.items[index].properties.pack;
                }
              }
            }

            this.style.display = 'block';
            if (cart.items.length == 0) this.style.display = 'none';
          } else {
            let bundleSummaryProducts = document.querySelector('[data-bundle-summary-products]');

            if (bundleSummaryProducts !== null) nbItemsInBundle = parseInt(bundleSummaryProducts.dataset.productsCount);
          }

          for (let index = 0; index < settingsData.length; index++) {
            if (nbItemsInBundle >= parseInt(settingsData[index].treshold)) {
              progressTresholds[index].classList.add('active');
              progressBarPreviousStepPosition = index + 1;
              progressBarPreviousStepTreshold = parseInt(settingsData[index].treshold);

              if (index < settingsData.length - 1) {
                progressStepIndex = index + 1;
                progressBarNextStepPosition = index + 2;
                progressBarNextStepTreshold = parseInt(settingsData[progressStepIndex].treshold);
              } else {
                progressStepIndex = index;
                progressBarNextStepPosition = index + 1;
                progressBarNextStepTreshold = parseInt(settingsData[progressStepIndex].treshold);
              }
            } else {
              progressTresholds[index].classList.remove('active');
            }
          }

          let tresholdRange = progressBarNextStepTreshold - progressBarPreviousStepTreshold;
          let amountFromPreviousStep = nbItemsInBundle - progressBarPreviousStepTreshold;
          let percentFromPreviousStep = (amountFromPreviousStep * 100) / tresholdRange;

          let progressBarStepWidth = 100 / settingsData.length / 2;
          let progressBarPreviousStepWidth = (progressBarPreviousStepPosition * 2 - 1) * progressBarStepWidth;
          let progressBarNextStepWidth = (progressBarNextStepPosition * 2 - 1) * progressBarStepWidth;

          if (progressBarPreviousStepWidth < 0) progressBarPreviousStepWidth = 0;

          let widthRange = progressBarNextStepWidth - progressBarPreviousStepWidth;
          let percentDistanceFromPreviousStep = (widthRange * percentFromPreviousStep) / 100;

          if (nbItemsInBundle < parseInt(progressMaxTreshold)) {
            amountLeftForNextTreshold = progressBarNextStepTreshold - nbItemsInBundle;
            progressMessage.innerHTML = settingsData[progressStepIndex].text.replace('&#39;', "'");
            if (progressMessage.querySelector('span') !== null)
              progressMessage.querySelector('span').textContent = amountLeftForNextTreshold;
            progressBarWidth = progressBarPreviousStepWidth + percentDistanceFromPreviousStep;
          } else {
            progressMessage.innerHTML = finalTextData;
            progressBarWidth = 100;
          }

          progressBar.style.width = progressBarWidth + '%';

          if (this.type == 'pack') {
            let bundleSummaryMessage = document.querySelector('[data-bundle-summary-message]');
            bundleSummaryMessage.innerHTML = progressMessage.innerHTML;
          }
        }
      }
    }
  );
}

if (!customElements.get('upsell-container')) {
  customElements.define(
    'upsell-container',
    class UpsellContainer extends HTMLElement {
      constructor() {
        super();

        let selectors = {
          upsellSlider: '[data-flickity]',
          upsellSliderData: 'flickity',
          upsellAddToCartPack: '[data-upsell-add-to-cart-pack]',
          upsellAddToCart: '[data-upsell-add-to-cart]',
          upsellAddToCartData: 'upsellAddToCart',
          upsellAddToCartPackData: 'upsellAddToCartPack'
        };

        this.selectors = selectors;
        this.desktopLayout = this.dataset.layoutDesktop;

        this.init();
        this.setupEventListeners();
      }

      async init() {
        if (this.querySelector(this.selectors.upsellSlider) !== null) {
          let sliderConfig = this.querySelector(this.selectors.upsellSlider).dataset[this.selectors.upsellSliderData];
          let slider = new themeVendor.Flickity(this.querySelector(this.selectors.upsellSlider), JSON.parse(sliderConfig));

          if (window.innerWidth >= 990 && this.desktopLayout == 'vertical') slider.destroy();
        }

        const buttons = this.querySelectorAll(this.selectors.upsellAddToCart);

        var self = this;
        buttons.forEach(function (button, index) {
          button.removeEventListener('click', self.addUpsell.bind(self));
          button.addEventListener('click', self.addUpsell.bind(self));
        });
      }

      setupEventListeners() {
        window.addEventListener('resize', this.onWindowResize.bind(this));
      }

      addUpsell(event) {
        var id = event.target.dataset[this.selectors.upsellAddToCartData];
        var data = 'form_type=product&utf8=%E2%9C%93&id=' + id + '&quantity=1';

        if (event.target.dataset[this.selectors.upsellAddToCartPackData] == 'true') {
          data = data + '&properties[isBundle]=true';
        }

        const container = event.target.closest('.cart_upsell__cell-container');
        const sellingPlanId = container ? container.dataset.sellingPlanId : null;

        if (sellingPlanId) {
          data = data + '&selling_plan=' + sellingPlanId;
        }

        window.cart.addToCart(data, null, null);
      }

      onWindowResize(event) {
        this.init();
      }
    }
  );
}

if (!customElements.get('gift-card-container')) {
  customElements.define(
    'gift-card-container',
    class GiftCardContainer extends HTMLElement {
      constructor() {
        super();

        let selectors = {
          giftCardBlock: '[data-gift-card-block]',
          giftCardInput: '[data-gift-card-add]',
          giftCardId: 'giftCardId',
          giftCardHandle: 'giftCardHandle',
        };

        let classes = {
          hidden: 'hidden',
        };

        this.selectors = selectors;
        this.classes = classes;

        this.init();
      }

      async init() {
        const cart = await getCartJSON();

        const inputs = this.querySelectorAll(this.selectors.giftCardInput);

        var self = this;
        inputs.forEach(function (input, index) {
          input.removeEventListener('click', self.addGiftCard.bind(self));
          input.addEventListener('click', self.addGiftCard.bind(self));
        });
      }

      addGiftCard(event) {
        var id = event.target.dataset[this.selectors.giftCardId];
        var data = 'form_type=product&utf8=%E2%9C%93&id=' + id + '&quantity=1';
        window.cart.addToCart(data, null, null);
      }
    }
  );
}

function stringifyPercentage(percentage) {
  return `${percentage}%`;
}